import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../../../http-error-handler.service';
import { EndpointLocationProviderService } from '../../../shared/services/endpoint-location-provider.service';

@Injectable({
    providedIn: 'root'
})
export class GerarSolicitacaoService {

    private env = environment;
    private handleError: HandleError;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('SolicitacaoService');
    }

    add(solicitacao, paginaPai) {
        let endpoint = `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_SOLICITACAO)}/api/Add`;

        if (paginaPai === 'RelatorioVendas') {
            endpoint = `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS_SEGREGADO)}/Vendas/api/RelatorioVendas/Add`;
        }

        return this.http
            .post(endpoint, JSON.stringify(solicitacao))
            .pipe(
                catchError(this.handleError('Cadastrar solicitação'))
            );
    }

    getListProdutoByACAR(idAutoridadeCertificadora, idAutoridadeRegistro, paginaPai): Observable<any> {
        let endpoint = `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_SOLICITACAO)}/api/GetListProdutoByACAR/${idAutoridadeCertificadora}/${idAutoridadeRegistro}`;

        if (paginaPai === 'RelatorioVendas') {
            endpoint = `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS_SEGREGADO)}/Vendas/api/RelatorioVendas/GetListProdutoByACAR/${idAutoridadeCertificadora}/${idAutoridadeRegistro}`;
        }

        return this.http
            .get(endpoint)
            .pipe(
                catchError(this.handleError('Buscar lista dos Produtos', []))
            );
    }

    sendEmail(dados, paginaPai) {
        let endpoint = `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_SOLICITACAO)}/api/SendEmail`;

        if (paginaPai === 'RelatorioVendas') {
            endpoint = `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS_SEGREGADO)}/Vendas/api/RelatorioVendas/SendEmail`;
        }

        return this.http
            .post(endpoint, dados)
            .pipe(
                catchError(this.handleError('Enviar email'))
            );
    }

    consultaContador(cpfContador) {
        return this.http
            .post(`${this.env.API_ENDPOINT_CONTADORPARCEIRO.link}?cpfContador=${cpfContador}`, null)
            .pipe(
                catchError(this.handleError('Buscar contador'))
            );
    }

    cupomDesconto(obj) {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PARTNER)}/api/GetVoucher`, obj)
            .pipe(
                catchError(this.handleError('Buscar cupom de desconto'))
            );
    }

    get(protocolo): Observable<any> {
        return this.http
          .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_SOLICITACAO)}/api/GetSolicitacao/${protocolo}`)
          .pipe(
            catchError(this.handleError('Buscar solicitação', []))
          );
      }

    getUrlNotificacao(protocolo): string {
        return `${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_SAFE2PAY)}/api/Callback/NotifyV2/${protocolo}`;
      }
}
